export type ArticleRenderData = {
  html: string;
  articleId: number;
  articleTitle: string;
};

let pendingArticleData: ArticleRenderData | null = null;
let articleRenderCallback: ((data: ArticleRenderData) => void) | null = null;

export function setArticleRenderCallback(
  callback: ((data: ArticleRenderData) => void) | null,
) {
  articleRenderCallback = callback;

  if (articleRenderCallback && pendingArticleData) {
    articleRenderCallback(pendingArticleData);
    pendingArticleData = null;
  }
}

export const queueArticleRender = (data: ArticleRenderData) => {
  if (articleRenderCallback) {
    articleRenderCallback(data);
  } else {
    pendingArticleData = data;
  }
};
